export const ROLES = ['CLIENT', 'PROVIDER', 'AGENT', 'ADMIN'] as const;
export type Role = (typeof ROLES)[number];

export const LANGUAGES = ['en', 'am'] as const;
export type Language = (typeof LANGUAGES)[number];

export const GENDERS = ['MALE', 'FEMALE'] as const;
export type Gender = (typeof GENDERS)[number];

export const BOOKING_STATUSES = [
  'PENDING',
  'ACCEPTED',
  'DECLINED',
  'EXPIRED',
  'CANCELLED_BY_CLIENT',
  'CANCELLED_BY_PROVIDER',
  'COMPLETED',
  'DISPUTED',
  'CLOSED',
] as const;
export type BookingStatus = (typeof BOOKING_STATUSES)[number];

/** Bottom tabs for each role in the Mini App. Keys map to i18n `tab.*`. */
export const TABS_BY_ROLE: Record<Role, readonly string[]> = {
  CLIENT: ['home', 'search', 'chats', 'bookings', 'profile'],
  PROVIDER: ['requests', 'chats', 'otherProviders', 'profile'],
  AGENT: ['myProviders', 'agentRequests', 'otherProviders', 'profile'],
  ADMIN: ['dashboard', 'profile'],
};

/** Minimum provider age. Enforced on the server. */
export const MIN_PROVIDER_AGE = 18;

/** Query-string keys the bot puts in Mini App links so a tap opens the right page. */
export const DEEP_LINK = { tab: 'tab', chat: 'chat', booking: 'booking', provider: 'provider' } as const;
